import {
  StopStatus,
  StopType,
  VendingVehicleScheduleState,
} from '../redux/type';
import { pageInfo } from './constant';
import { request } from '../fetch/core';
import { stringToEnum } from './util';
import { Method } from '@/fetch/core/util';
export * from './parseGeoJson';

export interface UpgradeDetail {
  appName?: string;
  appAlias?: string;
  issueTaskNumber?: string;
  version?: string;
  upgradeType?: number;
  upgradeTypeName?: string;
  progressType?: number;
  progressTypeName?: string;
  downloadStep?: string;
  upgradeStep?: string;
  estimatedCompletionTime?: string;
  failedReason?: string;
  downloadMethod?: string; // FULL_SPEED or LIMIT_SPEED
}
export enum MapType {
  CityLevelMap = 0,
  StationLevelMap = 1,
  ControlLevelMap = 2,
  SingleVehicleMap = 3,
}
interface Marker {
  name: string;
  lat: number;
  lon: number;
  id: number;
  tipsInfo?: string;
  hasAlarmEvent?: boolean | undefined;
  vehicleBusinessType?: string;
}
interface Stop {
  name: string;
  lat: number;
  lon: number;
  id: number;
  stopType: StopType;
  status: StopStatus;
  tipsInfo: string;
}
interface MapData {
  station: {
    [id: number]: Marker;
  };
  status: {
    [id: number]: {
      [vId: number]: Marker;
    };
  };
  stop: {
    [id: number]: {
      [sId: number]: Stop;
    };
  };
  finishedRoutingPoint: {
    [id: number]: { lat: number; lon: number }[];
  };
  totalRoutingPoint: {
    [id: number]: { lat: number; lon: number }[];
  };
  type: MapType;
  zoom: number;
  vehicleBusinessType: string;
}

export const isMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
);

export const addClass = () => {
  // 判断是否移动端
  const isPhone = isMobile;
  if (isPhone) {
    document.body.className = 'm-app';
  }
};

export const isNullObject = (obj: any) => {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
};

export const isEmpty = (param: any) => {
  if (Array.isArray(param) || typeof param === 'string') {
    return param.length === 0;
  }
  return true;
};

export const formatTime = (ms: number) => {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};

export const translator = (
  latLng: any,
  cb: AnyFunc,
  useTranslator: boolean = false,
) => {
  const winAny = window as any;
  const { qq } = winAny;
  if (useTranslator) {
    qq.maps.convertor.translate(latLng, 1, cb);
  } else {
    cb([latLng]);
  }
};
export const getPermissionById = (id: string) => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  const state = store.getState();
  const { resourceList } = state.login;
  if (resourceList) {
    const findIndex = resourceList.findIndex((item: any) => item.code === id);
    return findIndex > -1;
  }
  return false;
};

export const getPermissionTabs = (allPermissions: any[]) => {
  const pageInPermission: any = [];
  if (allPermissions) {
    for (const pageKey in pageInfo) {
      if (pageInfo[pageKey]) {
        // 警情查看页面需要验证三个tab签存在至少一个有权限
        let findIndex = -1;
        if (pageKey === 'spv_alarm_info') {
          const tabKeys = [
            'spv_alarm_history',
            'spv_error_history',
            'spv_jira_history',
          ];
          findIndex = allPermissions.findIndex((item: any) =>
            tabKeys.includes(item.code),
          );
        } else {
          findIndex = allPermissions.findIndex(
            (item: any) => item.code === pageKey,
          );
        }

        if (findIndex > -1) {
          pageInPermission.push(pageInfo[pageKey]);
        }
      }
    }
  }

  return pageInPermission;
};

export const getNewPermissionTabs = () => {
  const store = (window as any).store;
  if (!store) {
    return false;
  }
  const state = store.getState();
  const pageInPermission: any = [];

  const { resourceList } = state.login;
  if (resourceList && resourceList.length > 0) {
    for (const pageKey in pageInfo) {
      if (pageInfo[pageKey]) {
        let findIndex = -1;
        if (pageKey === 'spv_alarm_info') {
          // 警情查看页面需要验证三个tab签存在至少一个有权限
          const tabKeys = [
            'spv_alarm_history',
            'spv_error_history',
            'spv_jira_history',
          ];
          findIndex = resourceList.findIndex((item: any) =>
            tabKeys.includes(item.code),
          );
        } else {
          findIndex = resourceList.findIndex(
            (item: any) => item.code === pageKey,
          );
        }
        if (findIndex > -1) {
          pageInPermission.push(pageInfo[pageKey]);
        }
      }
    }
  }

  return pageInPermission;
};

/**
 *
 * @param {string} enumGroupKey 枚举分组key
 * @param {string} fieldKey 字段key
 * @return {Object}
 */
export const enumTranslator = (enumGroupKey: string, fieldKey: string) => {
  const win = window as any;
  const { common } = win.store.getState();
  const enumListMap = common.enumListMap;
  const storageMap = JSON.parse(localStorage.getItem('ENUM_LIST_MAP') || '{}');
  const mapEnum =
    enumListMap &&
    enumListMap[enumGroupKey] &&
    enumListMap[enumGroupKey].find((item: any) => item.code === fieldKey);
  if (!mapEnum) {
    return (
      (storageMap[enumGroupKey] &&
        storageMap[enumGroupKey].find((item: any) => item.code === fieldKey) &&
        storageMap[enumGroupKey].find((item: any) => item.code === fieldKey)
          .name) ||
      fieldKey
    );
  }
  return mapEnum.name;
};

export const translatorVendingScheduleState = (key: string) => {
  return stringToEnum(VendingVehicleScheduleState, key) || '';
};

export const formatMapData = (params: {
  nation: boolean;
  zoom: number;
  showFinishedRouting: boolean;
  city?: City;
  station?: Station;
  vehicle?: Vehicle;
}) => {
  const win = window as any;
  const store = win.store.getState();
  const { common } = store;
  const { alarmEventList } = common;
  const { nation, zoom, showFinishedRouting, city, station, vehicle } = params;
  const data: any = {
    city: {},
    station: {},
    vehicle: {},
    stop: {},
    finishedRoutingPoint: {},
    totalRoutingPoint: {},
    zoom,
  };
  if (nation) {
    data.city = common.city;
    return data;
  }

  if (station) {
    for (const stationItem of Object.values(station)) {
      const { name, lat, lon, id } = stationItem;
      data.station[id] = {
        name,
        lat,
        lon,
        id,
      };
    }
  }

  if (vehicle) {
    for (const vehicleItem of Object.values(vehicle)) {
      const {
        lat,
        lon,
        name,
        stop,
        finishedRoutingPoint,
        planningRoutingPoint,
        businessType,
      } = vehicleItem;

      data.vehicle[name] = {
        name,
        lat,
        lon,
        vehicleBusinessType: businessType,
        hasAlarmEvent: alarmEventList[name],
      };

      if (stop && !isEmpty(stop)) {
        data.stop[name] = {};
        stop.forEach((stopItem: StopItem, index: number) => {
          if (stopItem.lat && stopItem.lon) {
            data.stop[name][index] = stopItem;
          }
        });
      }
      if (showFinishedRouting) {
        data.finishedRoutingPoint[name] = finishedRoutingPoint || [];
      }
      data.totalRoutingPoint[name] = planningRoutingPoint || [];
    }
  }
  return data;
};

export const transformLocationWgs84togcj02 = (location: {
  lon: any;
  lat: any;
}): { lon: number; lat: number } => {
  const win = window as any;
  const formatedLoaction = win
    .coordtransform()
    .wgs84togcj02(parseFloat(location.lon), parseFloat(location.lat));
  return { lon: formatedLoaction[0], lat: formatedLoaction[1] };
};

/**
 * 形如12:02的时间字符串
 * @param {string} time 时间字符串
 * @return {number}
 */
export const formatDayTime = (time: string) => {
  if (typeof time != 'string') {
    return -1;
  }
  const [hours, minutes] = time?.split(':') || [];
  return parseInt(minutes) * 60 + parseInt(hours) * 3600;
};

/**
 * 校验两个picker时间区间是否有重叠
 * @param {Object} source 对比项
 * @param {Object} current 被对比项
 * @return {boolean}
 */
export const validatePickerItem = (source: any, current: any) => {
  if (!source.value || !current.value) {
    return false;
  }
  const [startTimeStr, endTimeStr] = source.value.split('-');
  const formatStart = formatDayTime(startTimeStr);
  const formatEnd = formatDayTime(endTimeStr);
  const [start, end] = current.value.split('-');
  const formatStartNum = formatDayTime(start);
  const formartEndNum = formatDayTime(end);
  const hasCross =
    (formatStart >= formatStartNum && formatStart <= formartEndNum) ||
    (formatEnd >= formatStartNum && formatEnd <= formartEndNum) ||
    (formatStart <= formatStartNum && formatEnd >= formartEndNum);
  return hasCross;
};

export function isString(opt: any): boolean {
  return typeof opt === 'string';
}

export function isFunction(opt: any): boolean {
  return typeof opt === 'function';
}

export function getRandom(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min)) + min;
}
export function debounce(fn: any, wait: number = 50) {
  let timer: any = null;
  return function (..._args: any) {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      fn.apply(null, _args);
    }, wait);
  };
}

export const formatSelectOptions = (
  list: { code: string | number; name: string }[] | null,
) => {
  if (!list) {
    return [];
  }
  return list.map((item) => {
    return {
      label: item.name,
      value: item.code,
    };
  });
};

export const setDb = (num: number) => {
  if (num < 10) {
    return '0' + num;
  } else {
    return '' + num;
  }
};

export function formatTimetoString(time: number) {
  const hour = setDb(Math.floor((time % 86400000) / 3600000));
  const minutes = setDb(Math.floor((time % 3600000) / 60000));
  const seconds = setDb(Math.floor((time % 60000) / 1000));
  const timeLong1 = hour + ':' + minutes + ':' + seconds;
  return timeLong1;
}

export const createRequestId = () => {
  return Math.ceil(Math.random() * 1000000);
};
export const isNumber = (value: any) => {
  return typeof value === 'number' && !isNaN(value);
};
